<template>
	<div class="w-100 p-3 bg-white border-15 overflow-auto">
		<table class="table">
			<tr class="border">
				<td class="bMikhak p-3 text-center">
					نام و نام‌خانوادگی
				</td>
				<td class="bMikhak p-3 text-center">
					شماره تماس
				</td>
				<td class="bMikhak p-3 text-center">
					لندینگ
				</td>
				<td class="bMikhak p-3 text-center">
					تاریخ
				</td>
				<td class="bMikhak p-3 text-center">
					پیگیری کننده
				</td>
			</tr>
			<tr v-for="(f, i) in flds.content" :key="i">
				<td class="text-center">
					{{f.fullname}}
				</td>
				<td dir="ltr" class="text-center">
					{{f.phone}}
				</td>
				<td class="text-center">
					{{ f.landing }}
				</td>
				<td class="text-center">
					{{ f.date }}
				</td>
				<td class="text-center text-danger pointer" v-if="!f.admins_fullname" @click="setStats(i)">
					پیگیری نشده است
				</td>
				<td class="text-center text-success" v-else>
					{{ f.admins_fullname }}
				</td>
			</tr>
		</table>
		<br/>
		<br/>
		<div class="w-100" style="display: flex; align-items: center; justify-content: center;">
			<pageNavigation :page="flds.curPage" :pages="flds.totalPages" @setPage="setPage"  />
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import userImg from  "../../UI/userImg/userImg.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";

		export default {
			name: 'teachers_part1',
			data(){
				return {
				}
			},
			components: {
				btn,
				pageNavigation,
				userImg,
			},
			props: {
				flds: {
					default: [],
				},
			},
			mounted(){

			},
			methods:{
				setStats(i, THIS=this){
					window.$.post(window.baseurl+"report_landing/"+this.flds.content[i].id, {
						token: this.$localStorage.get("user") 
					}, function(D){
						THIS.flds.content[i].admins_fullname  = THIS.$localStorage.get("user").username.fullname;
					}, "json");
				},
				setPage(page){
					this.$emit('setPage', page);
				}
			}
		}
	</script>
<style>

</style>
